import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProviderRatingRoutingModule } from './provider-rating-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ProviderRatingRoutingModule
  ]
})
export class ProviderRatingModule { }
